/* eslint-disable react-hooks/exhaustive-deps */
import { getReadableFormatNumber, numberToCommas } from "@/lib/utils/StringUtility";
import React, { useContext } from "react";
import { LoadingStateProps } from "@/types/types.d";
import { SummaryComparisonCard } from "../../../Cards/SummaryComparisonCard";
import getSymbolFromCurrency from "currency-symbol-map";
import AppLifecycleContext from "@/lib/contexts/AppLifecycleContext";

type Props = {
  loading: LoadingStateProps;
  comparisonData: any;
  activeWorkspace?: any;
};

const ConversionValueComparison = ({ loading, comparisonData, activeWorkspace }: Props) => {
  return (
    <div data-cy="events-card">
      <SummaryComparisonCard
        uniquekey={"uniqueVisitors"}
        loading={loading}
        comparisonValue={`${getSymbolFromCurrency(
          activeWorkspace.reporting_currency
        )}${getReadableFormatNumber(comparisonData?.total_conversion_value)}`}
        comparisonTooltip={`${numberToCommas(comparisonData.total_conversion_value)} Value `}
      />
    </div>
  );
};
const ConversionValueComparisonMemoized = React.memo(ConversionValueComparison);
export { ConversionValueComparisonMemoized as ConversionValueComparison };
